<div *ngIf="activeCard" class="work_area cards-component">
  <span
    class="cards-component__delete-button">
    <button mat-icon-button aria-label="Удалить вариант"
      (click)="openModal(DeleteCardModal)"
      [disabled]="!activeCard?.prev_results">
      <mat-icon>delete</mat-icon>
    </button>
    <ng-template
      class="modal fade in"
      data-backdrop="false"
      #DeleteCardModal>
      <div class="modal-body">
        <app-delete-card
          (closeBtnClicked)="closeModal()"
          (deleteBtnClicked)="deleteCard()"
        ></app-delete-card>
      </div>
    </ng-template>
  </span>
  <div class="card-message"
       *ngIf="activeCard?.prev_results && !isAuthorCard || activeCard?.prev_results && !isAccessCard">
    <p>Данный вариант решил ученик:
      <b>{{ activeCard?.prev_results.student.name }} {{ activeCard?.prev_results.student.surname }}</b>
    </p>
  </div>
  <div class="cards-component__card">
    <span class="cards-component__card__tasks">
      <div *ngFor="let exercise of activeCard.exercises; let exerIndex = index;">
        <table class="task" *ngIf="exercise.type == calculation || exercise.type == sequence || exercise.type == insert">
          <app-exercise-calc
            [exercise]="exercise"
            [exerIndex]="exerIndex"
            [studentId]="student.id"
            [cardId]="activeCard.id"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            [prev_results]="activeCard.prev_results?.results"
            (answered)="exerciseCalcAnswered($event)"
          ></app-exercise-calc>
        </table>
        <div *ngIf="exercise.type == task || exercise.type == logic">
          <app-exercise-task
            [exercise]="exercise"
            [exerIndex]="exerIndex"
            [studentId]="student.id"
            [cardId]="activeCard.id"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            [prev_results]="activeCard.prev_results?.results"
            (exerciseCorrect)="questionExerciseCorrect($event)"
            (answers)="questionExerciseAnswers($event, exercise)"
          ></app-exercise-task>
        </div>
        <div *ngIf="exercise.type == magic_box">
          <app-exercise-magic-box
            [exercise]="exercise"
            [exerIndex]="exerIndex"
            [studentId]="student.id"
            [cardId]="activeCard.id"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            [prev_results]="activeCard.prev_results?.results"
            (answered)="exerciseCalcAnswered($event)"
          ></app-exercise-magic-box>
        </div>
        <ng-container *ngIf="[puzzle_example, puzzle_task].includes(exercise.type)">
          <app-exercise-puzzle
            [exercise]="exercise"
            [index]="exerIndex"
            [viewType]="'teacher'"
            [activeCard]="activeCard"
            [isAccessCard]="isAccessCard"
            [isAuthorCard]="isAuthorCard"
            (exerciseCorrect)="questionExerciseCorrect($event)"
            (answers)="questionExerciseAnswers($event, exercise)">
          </app-exercise-puzzle>
        </ng-container>
      </div>
    </span>
    <span class="cards-component__card__settings">
      <div class="reviewer" *ngIf="activeCard.box?.check_character || activeCard.box?.risk_character">
        <span class="reviewer__label">Проверяет:</span>
        <div class="reviewer__privileges">
          <div class="reviewer__privilege"
               *ngIf="activeCard.box?.check_character && activeCard.box?.check_character_obj.icon">
            <img class="privilege__icon"
                 [src]="mainDomain + activeCard.box.check_character_obj.icon_url"
                 (click)="characterSelected(false)"
                 [ngClass]="{'offline': riskCharacterIsSelected}"
                 [title]="activeCard.box?.check_character_obj.title"
                 alt="персонаж проверки без риска">
          </div>
          <div class="reviewer__privilege reviewer_risk"
               *ngIf="activeCard.box?.risk_character && activeCard.box?.risk_character_obj.icon">
            <img class="privilege__icon"
                 [src]="mainDomain + activeCard.box?.risk_character_obj.icon_url"
                 (click)="characterSelected(true)"
                 [ngClass]="{'offline': !riskCharacterIsSelected}"
                 [title]="activeCard.box?.risk_character_obj.title"
                 alt="персонаж проверки с риском">
          </div>
        </div>
      </div>
      <br>
      <div class="cards-component__card__settings__level">
        <p>Box {{ activeCard.box?.title }} / Уровень {{ activeCard.box_level }}</p>
      </div>
      <table class="cards-component__card__settings__table">
        <tr class="setting" *ngIf="cardSettings && cardSettings.reward > 0">
          <td class="setting__value">{{ cardSettings?.reward }}</td>
          <td class="setting__name">Вознаграждение</td>
        </tr>
        <tr class="setting" *ngIf="cardSettings && cardSettings.cost">
          <td class="setting__value">{{ cardSettings?.cost }}</td>
          <td class="setting__name">Стоимость варианта</td>
        </tr>
        <tr class="setting" *ngIf="cardSettings && cardSettings.penalty">
          <td class="setting__value">{{ cardSettings?.penalty }}</td>
          <td class="setting__name">Штраф</td>
        </tr>
        <tr class="setting" *ngIf="cardSettings && cardSettings.attempts">
          <td class="setting__value">{{cardSettings?.attempts}}</td>
          <td class="setting__name">Повторная проверка</td>
        </tr>
        <tr class="setting" *ngIf="cardSettings && hasKairosBonus && cardSettings.kairos_bonus">
          <td class="setting__value">{{cardSettings?.kairos_bonus}}</td>
          <td class="setting__name">
            Кайрос бонус
            <img
              class="setting__icon"
              src="/assets/images/privilege_icons/kairos_bonus_icon.png"
              alt="Кайрос бонус">
          </td>
        </tr>
      </table>
      <div class="game__settings__privileges">
        <ul class="privileges">
          <li
            class="privilege"
            *ngFor="let privilege of studentActivePrivileges;"
            [ngClass]="{'small': studentActivePrivileges.length > 3}">
            <img
              [src]="mainDomain + privilege.character.icon_url"
              [alt]="privilege.character.title"
              [title]="privilege.privilege.title">
          </li>
        </ul>
      </div>
    </span>
  </div>
  <ng-container *ngIf="lesson.is_habirint">
    <div class="coach-form" [formGroup]="coachForm">
      <span class="coach-form__lable">Коуч: </span>
      <span class="coach-form__select">
        <select formControlName="coachItem">
          <option *ngFor="let student of students" [value]="student.id">
            {{ student.surname }} {{ student.name }}
          </option>
        </select>
      </span>
    </div>
  </ng-container>
  <div>
    <div class="work_area__ex-exercise" *ngIf="!cardResultId && exExercise?.id">
      <div class="extra-exercise extra-exercise_checkbox">
        <input
          type="checkbox"
          id="exExercise"
          class="exExerciseChbox"
          hidden
          [disabled]="!allExercisesCorrect()"
          [checked]="allExercisesCorrect() && isShowExExerciseBtn"
          (click)="clickExExercise()">
        <label for="exExercise" class="chbox">
          <span class="circle"></span>
        </label>
      </div>
      <div
        class="extra-exercise extra-exercise_title"
        [class.not-active]="!allExercisesCorrect()">
        Доп. задание: {{ exExercise.title }}
      </div>
      <div
        class="extra-exercise extra-exercise_correct-btn"
        (click)="isExtraExerciseActive = !isExtraExerciseActive"
        *ngIf="isShowExExerciseBtn && allExercisesCorrect()">
        <button *ngIf="!isExtraExerciseActive" class="button-add">+</button>
        <button class="button-icon" *ngIf="isExtraExerciseActive">
          <img src="/assets/images/icons/smile_good.png" alt="">
        </button>
      </div>
    </div>
    <div class="accept">
      <button
        [disabled]="!isAccessCard || !isAuthorCard"
        class="btn accept__button"
        (click)="openModal(resultModal)">
        ОК
      </button>
    </div>
  </div>
  <ng-template #resultModal>
    <div class="modal-body">
      <app-result-modal
        [card]="activeCard"
        [answers]="answers"
        [studentId]="student.id"
        [correctExercises]="correctExercises"
        [cardSettings]="cardSettings"
        [hasKairosBonus]="hasKairosBonus"
        [modalRef]="modalRef"
        [isExExerciseActive]="isShowExExerciseBtn"
        [exExercise]="exExercise"
        [exExerciseResult]="isExtraExerciseActive"
        (accepted)="sendAnswers($event)">
      </app-result-modal>
    </div>
  </ng-template>
</div>

<!-- модалка которая уведомляет учителя о том что ответы небыли сохранены -->
<ng-template #templateErrorMsg>
  <mat-dialog-content>
    <p>{{ errorMsg }}</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Хорошо</button>
  </mat-dialog-actions>
</ng-template>
